export enum AnalyticsInteractionType {
  Click = 'Click',
}

interface AnalyticsConfig {
  action?: string
  labels?: Array<{key: string; value: string}>
  interactionType?: AnalyticsInteractionType
  fullstoryDataRef?: string
}

/**
 * Returns the analytics object.
 * @param config - The configuration object for the analytics.
 * @returns object - The analytics object to be spread on elements.
 */
export function getAnalytics(config: AnalyticsConfig): Record<string, string> {
  const {action, labels = [], interactionType = AnalyticsInteractionType.Click, fullstoryDataRef} = config

  const actionValue = action ? `${AnalyticsInteractionType[interactionType]} ${action}` : undefined
  const updatedLabels = labels.map(({key, value}) => `${key}:${value}`)

  if (fullstoryDataRef) {
    updatedLabels.push(`data-ref:${fullstoryDataRef}`)
  }

  const labelValue = updatedLabels.join(';')
  const analyticsObject: Record<string, string> = {
    'data-analytics-event': JSON.stringify({
      action: actionValue,
      label: labelValue,
    }),
  }

  if (fullstoryDataRef) {
    analyticsObject['data-ref'] = fullstoryDataRef
  }

  return analyticsObject
}
